import api from './api';

// Admin table endpoints
const getTables = async (params = {}) => {
  try {
    // The merchant is automatically determined from the current logged-in user
    const response = await api.get('/tables/', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching tables:', error);
    throw error;
  }
};

const getTable = async (id) => {
  try {
    const response = await api.get(`/tables/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching table ${id}:`, error);
    throw error;
  }
};

const createTable = async (data) => {
  try {
    const response = await api.post('/tables/', data);
    return response.data;
  } catch (error) {
    console.error('Error creating table:', error);
    throw error;
  }
};

const updateTable = async (id, data) => {
  try {
    const response = await api.patch(`/tables/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating table ${id}:`, error);
    throw error;
  }
};

const deleteTable = async (id) => {
  try {
    const response = await api.delete(`/tables/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting table ${id}:`, error);
    throw error;
  }
};


const getAvailableTables = async (params = {}) => {
  try {
    // The merchant is automatically determined from the current logged-in user
    const response = await api.get('/tables/available/', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching available tables:', error);
    throw error;
  }
};

const generateTableQR = async (id) => {
  try {
    const response = await api.post(`/tables/${id}/generate-qr/`);
    return response.data;
  } catch (error) {
    console.error(`Error generating QR code for table ${id}:`, error);
    throw error;
  }
};

const getTableQRBase64 = async (id) => {
  try {
    const response = await api.get(`/tables/${id}/qr-base64/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching base64 QR code for table ${id}:`, error);
    throw error;
  }
};

const getBulkTableQRBase64 = async (tableIds) => {
  try {
    const response = await api.post('/tables/bulk-qr-base64/', { table_ids: tableIds });
    return response.data;
  } catch (error) {
    console.error('Error fetching bulk QR codes:', error);
    throw error;
  }
};

const getTableStatuses = async (params = {}) => {
  try {
    // The merchant is automatically determined from the current logged-in user
    const response = await api.get('/tables/statuses/', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching table statuses:', error);
    throw error;
  }
};

const getTableStatusesByStatus = async (params = {}) => {
  try {
    // The merchant is automatically determined from the current logged-in user
    const response = await api.get('/tables/statuses/by-status/', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching table statuses by status:', error);
    throw error;
  }
};

// Table Group endpoints
const getTableGroups = async (params = {}) => {
  try {
    const response = await api.get('/tables/groups/', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching table groups:', error);
    throw error;
  }
};

const createTableGroup = async (data) => {
  try {
    const response = await api.post('/tables/groups/', data);
    return response.data;
  } catch (error) {
    console.error('Error creating table group:', error);
    throw error;
  }
};

const updateTableGroup = async (id, data) => {
  try {
    const response = await api.put(`/tables/groups/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating table group ${id}:`, error);
    throw error;
  }
};

const deleteTableGroup = async (id) => {
  try {
    const response = await api.delete(`/tables/groups/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting table group ${id}:`, error);
    throw error;
  }
};

// Public table endpoints
const getPublicTableInfo = async (merchantId, tableId) => {
  try {
    const response = await api.get('/menus/public/table-menu/', {
      params: { merchant: merchantId, table: tableId }
    });
    return response.data.table;
  } catch (error) {
    console.error(`Error fetching public table info for table ${tableId}:`, error);
    throw error;
  }
};

// Table status specific actions
const setTableAvailable = async (id) => {
  try {
    const response = await api.post(`/tables/${id}/set-available/`);
    return response.data;
  } catch (error) {
    console.error(`Error setting table ${id} as available:`, error);
    throw error;
  }
};

const setTableOccupied = async (id, data = {}) => {
  try {
    const response = await api.post(`/tables/${id}/set-occupied/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error setting table ${id} as occupied:`, error);
    throw error;
  }
};

const setTableReserved = async (id) => {
  try {
    const response = await api.post(`/tables/${id}/set-reserved/`);
    return response.data;
  } catch (error) {
    console.error(`Error setting table ${id} as reserved:`, error);
    throw error;
  }
};

const setTableCleaning = async (id) => {
  try {
    const response = await api.post(`/tables/${id}/set-cleaning/`);
    return response.data;
  } catch (error) {
    console.error(`Error setting table ${id} as cleaning:`, error);
    throw error;
  }
};

const setTableMaintenance = async (id) => {
  try {
    const response = await api.post(`/tables/${id}/set-maintenance/`);
    return response.data;
  } catch (error) {
    console.error(`Error setting table ${id} as maintenance:`, error);
    throw error;
  }
};


const tableService = {
  // Admin endpoints
  getTables,
  getTable,
  createTable,
  updateTable,
  deleteTable,

  getAvailableTables,
  generateTableQR,
  getTableQRBase64,
  getBulkTableQRBase64,

  getTableStatuses,
  getTableStatusesByStatus,

  // Table Group endpoints
  getTableGroups,
  createTableGroup,
  updateTableGroup,
  deleteTableGroup,

  // Table status specific actions
  setTableAvailable,
  setTableOccupied,
  setTableReserved,
  setTableCleaning,
  setTableMaintenance,

  // Public endpoints
  getPublicTableInfo
};

export default tableService;
